// cSpell:enableCompoundWords
import FootballBackground from 'components/background/FootballBackground';
import FootballFieldModal from 'components/footballfieldmodal/FootballFieldModal';
import GameAdmin from 'components/gameadmin/GameAdmin';
import SqLoader from 'components/loader/SqLoader';
import NavBar from 'components/nav/NavBar';
import UserSettings from 'components/usersettings/UserSettings';
import { useAppDispatch, useAppSelector } from 'hooks/hooks';
import React, { Suspense, useEffect } from 'react';
import { Await, Outlet, useLoaderData } from 'react-router-dom';
import { getShowUserSettingsModal, ModalKind, setModal } from 'slices/SqModalSlice';
import styles from './App.module.scss';

const App: React.FC = () => {
  const userStatus = useLoaderData();
  const dispatch = useAppDispatch();

  // const isLoggedIn = useAppSelector(getIsUserLoggedIn);
  // const userAuthState = useAppSelector(getUserAuthState);
  // const auth.
  // const navigate = useNavigate();

  useEffect(() => {
    // dispatch(subscribeUserStatusChange());
    // dispatch(resetActiveForm());
  }, []);

  // useEffect(() => {
  //   if (location.pathname === SqRoutes.Home) {
  //     if (isLoggedIn) {
  //       const msgLobby = `${Emojis.eyes} %c ${userAuthState} %c navigating to %c Lobby %c`;
  //       console.log(`${msgLobby}`, ValueCls, '', LocationCls, '');
  //       navigate(SqRoutes.Lobby);
  //     } else if (!isLoggedIn && userAuthState === UserAuthState.NotLoggedIn) {
  //       const msgLobby = `${Emojis.eyes} %c ${userAuthState} %c navigating to %c Login %c`;
  //       console.log(`${msgLobby}`, ValueCls, '', LocationCls, '');
  //       navigate(SqRoutes.Login);
  //     } else if (!isLoggedIn && userAuthState === UserAuthState.LoggedOut) {
  //       const msgLobby = `${Emojis.eyes} %c ${userAuthState} %c navigating to %c Login %c`;
  //       console.log(`${msgLobby}`, ValueCls, '', LocationCls, '');
  //       navigate(SqRoutes.Login);
  //     }
  //   }
  // }, [location, isLoggedIn, userAuthState]);

  return (
    <div id="FootballSquaresId" className={styles.App}>
      <FootballBackground />
      <NavBar />
      <Suspense fallback={<SqLoader />}>
        <Await resolve={userStatus} errorElement={<div>BAD STUFF</div>}>
          <Outlet />
        </Await>
      </Suspense>
      <GameAdmin />
      <FootballFieldModal
        overlayCanClose
        openFromBottom
        show={useAppSelector(getShowUserSettingsModal)}
        onClose={() => dispatch(setModal({ kind: ModalKind.ShowUserSettingsModal, isVisible: false }))}
      >
        <UserSettings />
      </FootballFieldModal>
    </div>
  );
};

export default App;
